import React, { useState, useEffect } from "react";
import axios from "axios";
import api from "../api/axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const AddEditCategory = () => {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [products, setProduct] = useState([]);
  // product_list
  const category_image_detail = JSON.parse(
    localStorage.getItem("category-list")
  );
  const storedCategoryImageDetail = category_image_detail;
  const BASE_IMAGE_URL = `${BASE_URL}/`;
  const [initialImagePath, setInitialImagePath] = useState(null);
  const isEditMode = storedCategoryImageDetail?.id;

  useEffect(() => {
    // Check if data is available in localStorage
    if (
      storedCategoryImageDetail &&
      storedCategoryImageDetail?.id
    ) {
      // A. Pre-fill form state
      setFormData((prev) => ({
        ...prev,
        id: storedCategoryImageDetail.id || "",
        name: storedCategoryImageDetail.name || "",
        // Initialize other fields if necessary
      }));

      // B. Set image preview
      if (storedCategoryImageDetail.image) {
        const fullPath = storedCategoryImageDetail.image.startsWith("http")
          ? storedCategoryImageDetail.image
          : `${BASE_IMAGE_URL}${storedCategoryImageDetail.image}`;

        setPreview(fullPath);
        setInitialImagePath(fullPath);
      }
    } else {
      // If data is NOT in localStorage or ID doesn't match, fetch from API
      setFormData([]);
    }
  }, [isEditMode]); // Dependencies

  const history = useHistory();
  const [formData, setFormData] = useState({
    name: "",
    image: "",
  });
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  // handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // handle image file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(e.target.files[0]);
    if (file) {
      setPreview(URL.createObjectURL(file)); // create temporary image URL
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    if (image) {
      data.append("image", image);
    }
    try {
      let response;
      let url;
      let method; 

      if (isEditMode) {
        url = `/category/update/${isEditMode}`;
        method = api.post; 
      } else {
        url = `/category/create`; 
       method = api.post;
      }

      response = await method(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        const successMessage = isEditMode
          ? "Category updated successfully!"
          : "Category added successfully!";
        
        toast.success(successMessage);
        history.push("/category");
      } else {
         toast.error("Submission failed: " + (response.data.message || "Unknown error."))      
      }
    } catch (err) {
      const apiErrors = err.response?.data?.errors;
      if (apiErrors) {
         toast.error("Validation failed: " + Object.values(apiErrors).flat().join(" | "))
      
      } else {
         toast.error("Error submitting slider!");
      }
    }
  };
  return (
    <>
      <div className="main-content-inner">
        {/* <!-- main-content-wrap --> */}
        <div className="main-content-wrap">
          <div className="flex items-center flex-wrap justify-between gap20 mb-27">
            <h3>{isEditMode?"Edit Category":"Add Category"}</h3>
            <ul className="breadcrumbs flex items-center flex-wrap justify-start gap10">
              <li>
                <Link to="/">
                  <div className="text-tiny">Dashboard</div>
                </Link>
              </li>  
              <li>
                <i className="icon-chevron-right"></i>
              </li>
              <li>
                <div className="text-tiny">Add Category Image</div>
              </li>
            </ul>
          </div>
          {/* <!-- form-add-product --> */}
          <form
            className="tf-section-2 form-add-product"
            onSubmit={handleSubmit}
          >            
            <div className="wg-box">             
              <fieldset className="name">
                <div className="body-title mb-10">
                  Name <span className="tf-color-1">*</span>
                </div>
                <input
                  className="mb-10"
                  type="text"
                  placeholder="Enter category name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </fieldset>
              <fieldset className="mt-4">
                <div className="body-title mb-10">Upload Image</div>
                <input
                  type="file"
                  id="myFile"
                  name="image"
                  onChange={handleFileChange}
                  accept="image/*"
                  className="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 p-2"
                />

                {preview && (
                  <div className="mt-4">
                    <img                    
                      src={preview}
                      alt="Preview"
                      className="w-32 h-32 object-cover rounded-lg border border-gray-300"
                    />
                  </div>
                )}
              </fieldset>

              <div className="cols gap10 mt-4">
                <button className="tf-button style-1 w-full" type="submit">
                  Save Category
                </button>
              </div>
            </div>
          </form>
          {/* <!-- /form-add-product --> */}
        </div>
        {/* <!-- /main-content-wrap --> */}
      </div>
    </>
  );
};
export default AddEditCategory;
